export enum AuditionType {
  StudioSession = 'studio',
  SelfTapes = 'self_tapes',
}

export const auditionTypeParser = (auditionType: AuditionType) => {
  return auditionType === AuditionType.SelfTapes ? 'Self-Tapes' : 'Studio';
};
